import Colors from 'enums/Colors';
import styled from 'styled-components';

const StyledSecoundSession = {
    Container: styled.div`
        position: relative;
        display: flex;
        align-items: start;
        flex-direction: column;
        background-color: #f5f5f5;
        padding-top: 40px;
        padding-left: 280px;
        overflow: hidden;

        @media screen and (max-width: 1600px) {
            padding-left: 80px;
        }
        @media screen and (max-width: 500px) {
            padding-left: 20px;
            padding-top: 40px;
        }
    `,

    Content: styled.div`
        display: flex;
        flex-direction: column;
        max-width: 1280px;
    `,

    Column: styled.div`
        display: flex;
        gap: 16px;
        flex-direction: column;
    `,

    Row: styled.div`
        display: flex;
        align-items: center;
        gap: 8px;
        font-family: 'Barlow';
        font-weight: 600;
        font-size: 20px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
        color: ${Colors.Blue};
    `,
    RowButtons: styled.div`
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
    `,

    TagBlue: styled.div`
        background-color: ${Colors.SoftBlue};
        color: ${Colors.White};
        padding: 10px 20px;
        width: fit-content;
        border-radius: 200px;
    `,

    ContentAbas: styled.div`
        display: flex;
        gap: 32px;
        margin-top: 16px;
        margin-bottom: 16px;

        @media screen and (max-width: 1370px) {
            justify-content: start;
        }
        @media screen and (max-width: 750px) {
            flex-wrap: wrap;
            gap: 10px;
        }
    `,

    Aba: styled.button<{ active: boolean }>`
        width: 318px;
        height: 50px;
        border-radius: 8px;
        font-family: 'Barlow';
        font-weight: 700;
        font-size: 20px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
        text-transform: uppercase;
        border: none;

        background-color: ${({ active }) => (active ? Colors.Blue : '#CFCFCF')};
        color: ${Colors.White};

        @media screen and (max-width: 1370px) {
            width: 300px;
            font-size: 26px;
        }

        @media screen and (max-width: 1050px) {
            width: 200px;
            font-size: 18px;
        }
        @media screen and (max-width: 600px) {
            width: 120px;
            font-size: 14px;
        }
    `,

    Body: styled.div`
        display: flex;
        border-radius: 16px;
        background-color: ${Colors.White};
        padding: 35px 46px;
        justify-content: space-between;
        width: 100%;
    `,

    Title: styled.h1`
        font-family: 'Barlow';
        font-weight: 700;
        font-size: 32px;
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
        text-transform: uppercase;
        color: ${Colors.Blue};
        max-width: 680px;

        @media screen and (max-width: 1050px) {
            max-width: 100%;
        }

        @media screen and (max-width: 500px) {
            font-size: 22px;
        }
    `,

    Img: styled.img`
        max-width: 460px;
        object-fit: cover;
        height: 380px;
        border-radius: 16px;
        margin-top: 20px;

        @media screen and (max-width: 1060px) {
            display: none;
        }
    `,

    ImgCircule: styled.img`
        position: absolute;
        max-width: 460px;
        object-fit: cover;
        height: 538px;
        border-radius: 16px;
        margin-top: 20px;
        top: 491px;
        right: 0;

        @media screen and (max-width: 1920px) {
            right: -250px;
        }
       
      
        @media screen and (max-width: 1400px) {
            display: none;
        }
    `,

    Paragrafo: styled.p<{ fontSize?: string }>`
        font-family: 'Barlow';
        font-weight: 400;
        font-size: ${({ fontSize }) => (fontSize ? fontSize : '16px')};
        line-height: 150%;
        letter-spacing: -1%;
        vertical-align: middle;
        color: ${Colors.Blue};
        max-width: 520px;

        @media screen and (max-width: 1050px) {
            max-width: 100%;
        }
    `,

    ButtonOutline: styled.button`
        width: 250px;
        height: 46px;
        border-radius: 4px;
        border-width: 1px;
        padding-top: 10px;
        padding-right: 20px;
        padding-bottom: 10px;
        padding-left: 20px;
        gap: 10px;
        border: 1px solid ${Colors.Blue};
        color: ${Colors.Blue};
        background-color: ${Colors.White};
        text-decoration: underline;
    `,

    Module: {
        Row: styled.div`
            display: flex;
            align-items: center;
            justify-content: space-between;
        `,

        Info: styled.div`
            display: flex;
            flex-direction: column;

            font-family: 'Barlow';
            font-weight: 400;
            font-size: 18px;
            line-height: 150%;
            letter-spacing: -1%;
            vertical-align: middle;
            padding-bottom: 10px;
            color: ${Colors.Blue};
            gap: 1rem;

            h1 {
                max-width: 80%;
                font-weight: 500;
            }

            p {
                font-size: 18px;
                line-height: 26px;
            }
        `,
    },

    Actives: {
        Container: styled.div`
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 24px;

            @media screen and (max-width: 1000px) {
                grid-template-columns: 1fr;
            }
        `,

        Content: styled.div`
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: ${Colors.Blue};
            padding: 10px;
            padding-bottom: 24px;
            border-bottom: 1px solid ${Colors.Blue};
            transition: all 0.3s;

            h1 {
                font-family: 'Barlow';
                font-weight: 400;
                font-size: 18px;
                line-height: 150%;
                letter-spacing: -1%;
                vertical-align: middle;

                max-width: 70%;

                @media screen and (max-width: 600px) {
                    max-width: 90%;
                }
            }

            img {
                cursor: pointer;
            }

            &:hover {
                background-color: #F5F5F5;
                cursor: pointer;
            }
        `,
    },
};

export default StyledSecoundSession;
